module.exports = __webpack_public_path__ + "static/ride-spot-logo-promo-6100a8d5b15c848611f770e90f6c35c9.png";